import 'date-fns';
import React from 'react';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import TextField from '@material-ui/core/TextField';
import FormLabel from '@material-ui/core/FormLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import {useDropzone} from 'react-dropzone';

export default function Step6() {
    const {getRootProps, getInputProps, acceptedFiles} = useDropzone({noKeyboard: true});
    const files = acceptedFiles.map(file => <li key={file.path}>{file.path}</li>);
  return (
    <>

      <Grid container spacing={3}>
        <Grid item  xs={12} sm={3}>
            <TextField id="healthcarerendered" fullWidth label="Hospital" />
        </Grid>
        <Grid item  xs={12}  sm={6}>
            <TextField
            id="healthcareaddress1"
            fullWidth
            label="Address"
            />
        </Grid>
        <Grid item  xs={12} sm={3}>
            <TextField id="healthcarephone1" fullWidth label="Phone " />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid item  xs={12} sm={3}>
            <TextField id="healthcareparamedics" fullWidth label="Paramedics" />
        </Grid>
        <Grid item  xs={12}  sm={6}>
            <TextField
            id="healthcareaddress2"
            fullWidth
            label="Address"
            />
        </Grid>
        <Grid item  xs={12} sm={3}>
            <TextField id="healthcarephone2" fullWidth label="Phone " />
        </Grid>
      </Grid>


      <Grid container spacing={3}>
        <Grid item  xs={12} sm={3}>
            <TextField id="healthcareambulance" fullWidth label="Ambulance" />
        </Grid>
        <Grid item  xs={12}  sm={6}>
            <TextField
            id="healthcareaddress3"
            fullWidth
            label="Address"
            />
        </Grid>
        <Grid item  xs={12} sm={3}>
            <TextField id="healthcarephone3" fullWidth label="Phone " />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid item  xs={12} sm={3}>
            <TextField id="healthcaredoctor1" fullWidth label="Doctor" />
        </Grid>
        <Grid item  xs={12}  sm={6}>
            <TextField
            id="healthcareaddress4"
            fullWidth
            label="Address"
            />
        </Grid>
        <Grid item  xs={12} sm={3}>
            <TextField id="healthcarephone4" fullWidth label="Phone " />
        </Grid>
      </Grid>


      <Grid container spacing={3}>
        <Grid item  xs={12} sm={3}>
            <TextField id="healthcaredoctor2" fullWidth label="Doctor" />
        </Grid>
        <Grid item  xs={12}  sm={6}>
            <TextField
            id="healthcareaddress5"
            fullWidth
            label="Address"
            />
        </Grid>
        <Grid item  xs={12} sm={3}>
            <TextField id="healthcarephone5" fullWidth label="Phone " />
        </Grid>
      </Grid>

        <Grid container spacing={3}>
        <Grid item  xs={12}  sm={12}>
        <TextField id="healthcaredescribeinjuries" fullWidth label="Describe injuries" />           
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid item  xs={12} sm={3}>
            <TextField id="healthcarebruises" fullWidth label="Bruises or cuts?" />
        </Grid>
        <Grid item  xs={12}  sm={6}>
            <TextField
            id="healthcarewhere"
            fullWidth
            label="Where"
            />
        </Grid>
        <Grid item  xs={12} sm={12}>

            {/* <TextField type="file" accept="image/*" multiple="multiple" id="healthcarephotos" fullWidth label="Photos" /> */}
            <section className="container">
            <div {...getRootProps({className: 'dropzone'})} style={{backgroundColor: '#e0e0eb', padding: 5}}>
                <input {...getInputProps()} />
                <center><p>Drop Photos Here</p></center>
            </div>
            <aside>
                <h4>Files</h4>
                <ul>{files}</ul>
            </aside>
            </section>
        </Grid>
      </Grid>

        <Grid container spacing={3}>
        <Grid item  xs={12}  sm={12}>
        <TextField id="healthcarepriorinjuries" fullWidth label="Prior injuries (all)" />           
        </Grid>

        
      </Grid>

      


</>
    
  );

}
